import React, { createContext, useContext, useState, useCallback } from 'react';

/**
 * Lets QuoteBuilder.js (a descendant, rendered via <Outlet /> inside
 * TravelieLayout) push its live step/progress/quote-summary state UP to the
 * shared sidebar shell, which is an ancestor and can't reach into a child's
 * local state directly. TravelieLayout reads this to swap its normal nav for
 * a step-by-step quote builder nav (+ live summary) while a quote is being
 * built, matching the Figma "Voyager Pro" design - see AGENTS.md.
 *
 * `navState` is null whenever QuoteBuilder isn't mounted (normal nav shows).
 */
const QuoteBuilderNavContext = createContext({
  navState: null,
  setNavState: () => {},
});

export const QuoteBuilderNavProvider = ({ children }) => {
  const [navState, setNavStateRaw] = useState(null);
  // Stable identity so QuoteBuilder's effect dependency array doesn't churn.
  const setNavState = useCallback((value) => setNavStateRaw(value), []);
  return (
    <QuoteBuilderNavContext.Provider value={{ navState, setNavState }}>
      {children}
    </QuoteBuilderNavContext.Provider>
  );
};

export const useQuoteBuilderNav = () => useContext(QuoteBuilderNavContext);
